/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 9eddebd4 (Tue Feb 17 18:34:36 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface CommunitySelectOptions
 */
export interface CommunitySelectOptions {
  /**
   * Unique identifier for the community
   * @type number
   * @memberof CommunitySelectOptions
   */
  communityKey: number
  /**
   * The name of the community
   * @type string
   * @memberof CommunitySelectOptions
   */
  name: string
}

export function CommunitySelectOptionsFromJSON(
  json: any
): CommunitySelectOptions {
  return CommunitySelectOptionsFromJSONTyped(json, false)
}

export function CommunitySelectOptionsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CommunitySelectOptions {
  if (json === undefined || json === null) {
    return json
  }
  return {
    communityKey: json['communityKey'],
    name: json['name'],
  }
}

export function CommunitySelectOptionsToJSON(
  value?: CommunitySelectOptions | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    communityKey: value.communityKey,
    name: value.name,
  }
}
